<template>
  <!-- 树形选择框，只用于多选，见角色管理按功能授权 -->
  <div class="tree-select">
    <div class="option">
      <el-checkbox v-model="menuExpand" @change="handleCheckedTreeExpand($event)">展开/折叠</el-checkbox>
      <el-checkbox v-model="menuNodeAll" @change="handleCheckedTreeNodeAll($event)">全选/全不选</el-checkbox>
      <el-checkbox v-model="menuCheckStrictly" disabled @change="handleCheckedTreeConnect($event)">父子联动</el-checkbox>
    </div>
    <el-tree
        class="tree-border"
        :data="list"
        show-checkbox
        ref="menuRef"
        node-key="id"
        :check-strictly="!menuCheckStrictly"
        empty-text="无数据"
        :props="{ label: labelName, children: 'children' }"
        @checkChange="checkedChange"
        :default-checked-keys="defaultCheckedList"
    >
    </el-tree>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import {watch} from "vue";

export default {
  props: {
    modelValue: {default: ""},
    treeList: {default: ()=> []},
    labelName: {default: "dictName"},
    codeName: {default: "id"}
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
  },
  data() {
    return {
      menuExpand: false, // 展开/折叠
      menuNodeAll: false, // 全选/全不选
      menuCheckStrictly: true, // 父子联动
      list: [],
      defaultCheckedList: [],
    };
  },
  created() {
    this.initData();
    watch(() => this.modelValue, () => {this.initData();})
  },
  methods: {
    // 初始化数据，用于显示
    initData() {
      let treeList = this.treeList;
      if (this.modelValue) {
        // 有值，区分显示半选中和全选中
        let checked = [];
        this.treeNodeHalfChecked(this.modelValue.split(","), this.treeList, checked);
        this.defaultCheckedList = checked;
      }
      this.list = treeList;
    },
    // 由于父子联动，所以删掉父级节点的选中数据即可
    treeNodeHalfChecked(dataList, treeList, result) {
      for (let i = 0; i < dataList.length; i++) {
        for (let j = 0; j < treeList.length; j++) {
          if (dataList[i] === treeList[j][this.codeName]) {
            // 这个节点有被选中
            if (treeList[j].children && treeList[j].children.length > 0) {
              break;// 有下级子节点，跳过
            } else {
              result.push(dataList[i]);
            }
          } else if (treeList[j].children && treeList[j].children.length > 0) {
            // 这个节点有子节点，看子节点是否被选中
            this.treeNodeHalfChecked(dataList, treeList[j].children, result);
          }
        }
      }
    },
    handleCheckedTreeExpand(value) {
      let treeList = this.list;
      for (let i = 0; i < treeList.length; i++) {
        this.$refs.menuRef.store.nodesMap[treeList[i].id].expanded = value
      }
    },
    handleCheckedTreeNodeAll(value) {
      if (value) {
        // 获取所有叶子节点的 key
        const allLeafKeys = this.getAllLeafKeys(this.list);
        this.$refs.menuRef.setCheckedKeys(allLeafKeys);
      } else {
        this.$refs.menuRef.setCheckedKeys([]);
      }
    },
    handleCheckedTreeConnect(value) {
      this.menuCheckStrictly = !!value;
    },
    getAllLeafKeys(nodes) {
      let keys = [];
      for (const node of nodes) {
        keys.push(node.id);
        if (node.children && node.children.length > 0) {
          keys.push(...this.getAllLeafKeys(node.children));
        }
      }
      return keys;
    },
    // 选中情况发生变更,更新数据
    checkedChange() {
      let arr = this.$refs.menuRef.getCheckedNodes(false, true); // 获取所有选中的节点，包括半选中
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i][this.codeName])
      }
      this.$emit("update:modelValue", res.join(","));
    }
  }
};
</script>

<style lang="scss" scoped>
.tree-select{
  .option{
    display: flex;
    justify-content: space-between;
    .el-checkbox{
      margin: 0;
      :deep(.el-checkbox__label) {
        font-size: 12px;
      }
    }
  }
  .tree-border{
    border: 1px solid var(--yq-border-color);
    max-height: 300px;
    overflow: auto;
  }
}
</style>